import { combineReducers } from "redux";
import user from "./user";
import source from "./source.js";
import user_detail from "./user_detail";
import admin from "./admin.js";

export default combineReducers({
  user,
  source,
  user_detail,
  admin,
});
